import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import installVuewx from "@/shared/vue/plugins/vuewx";
import "@/css/global.less";

Vue.config.productionTip = false;

// check pc or mobile
let mobile = navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
);
const platform = mobile ? "mobile" : "pc";
// console.log('platform:', platform)

// fix 1px gap at the bottom on some page
// let m = document.body
// setInterval(function() {
//   m.style.height = 'auto'
//   m.style.height = Math.ceil(m.scrollHeight) + 'px'
// }, 1000)

installVuewx(Vue);

new Vue({
  router,
  platform: platform,
  render: (h) => h(App),
}).$mount("#app");
